<template>
  <div class="d-flex flex-column vh-100">
    <b-navbar toggleable="lg">
      <img class="logo ml-4 py-2" :src="logoURL" alt="logo da prefeitura" border="0" />
      <h3 class="mx-3">|</h3>
      <router-link :to="homePath" class="navbar-brand d-none d-sm-inline-block">
        <h4>
          {{ sigla }}
        </h4>
      </router-link>
      <b-navbar-nav class="ml-auto">
        <router-link class="px-3" v-show="useCase" :to="homePath">
          <b-button variant="outline-secondary" pill>
            <b-icon icon="arrow-return-left" variant="dark" />
            Voltar
          </b-button>
        </router-link>
        <b-navbar-nav class="ml-auto">
          <b-button v-if="this.$route.name === 'inicio'" pill  class="d-none d-md-block bg-primary-reativa">
            <a href="https://prefeitura.pbh.gov.br/" target="_blank" class="text-white" style="text-decoration: none">
              PORTAL DA PBH
            </a>
          </b-button>
          <b-button v-if="primeiroNome === 'Anônimo'" pill @click="redirectKeycloak" class="ml-3 px-3 bg-primary-reativa" >
            ACESSO IDENTIFICADO
          </b-button>
        </b-navbar-nav >
        <div v-if="primeiroNome !== 'Anônimo'">
          <b-nav-item-dropdown right>
            <template #button-content>
              <b-icon icon="person-fill" font-scale="1.5"></b-icon>
              <em>{{ primeiroNome }}</em>
            </template>
            <b-dropdown-item @click="logout">
              <i aria-hidden="true" class="fa fa-sign-out"></i>
              Sair
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </div>
      </b-navbar-nav>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    </b-navbar>

    <div v-if="this.$route.name === 'inicio'" class="conteudo  align-items-center flex-grow-1">
      <router-view></router-view>
    </div>

    <div v-else class="conteudo flex-grow-1">
      <router-view></router-view>
    </div>

    <rodape class="mt-auto py-2" :logoURL="logoURL" :versao="versao"></rodape>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mensagens: [],
      logoURL: "/imgs/prefeitura-2024.svg",
      origemAcesso: "",
    };
  },
  methods: {
    logout() {
      this.$store.commit(
        "SET_REDIRECT_URL_LOGOUT",
        window.envJson.url_frontend
      );
      this.$store.dispatch("LOGOUT_REQUEST");
    },

    redirectKeycloak() {
      // const nomeRota = this.$route.name === "inicio" ? "/" : `/${this.$route.path}`;
    
      // const redirectUri = `${this.$env.url_frontend}${nomeRota}`;
      // this.$store.getters.keycloak.login({ redirectUri });  

      const redirectUri = `${window.envJson.redirect_uri}/reativabh`;
      //  const redirectUri = "http://localhost:8080/";    
      this.$store.getters.keycloak.login({ redirectUri });      
    }
  },

  computed: {
    sigla() {
      return process.env.MIX_APP_SIGLA || process.env.VUE_APP_SIGLA;
    },

    homePath() {
      return "/";
    },

    useCase() {
      return this.$route.name !== "inicio";
    },

    versao() {
      return process.env.MIX_APP_VERSAO || process.env.VUE_APP_VERSAO;
    },

    primeiroNome() {
      return this.$store.getters.userInfo.given_name || "Anônimo";
    },

    origem() {
      return this.$store.getters.userInfo.origem || ""
    },

    matricula() {
      return this.$store.getters.userInfo.preferred_username || "";
    },
  },

  async beforeMount() {
    this.userName = this.$store.getters.userInfo.preferred_username;
    this.origemAcesso = this.$store.getters.userInfo.origem;
    this.origemNome = this.$store.getters.userInfo.name;
  },
};
</script>

<style>
:root {
  --bg-primary-reativa:#326496;
  --bg-hover-reativa:#37536f;
}

.bg-primary-reativa { 
  background-color: var(--bg-primary-reativa);
}

.bg-primary-reativa:hover {
  background-color: var(--bg-hover-reativa);
}

.bg-img {
  background-image: url(/imgs/fundo.png);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}

@media only screen and (max-width: 600px) {
  .bg-img {
    background-image: none;
    background-color: #007632;
  }
}

@media only screen and (min-width: 600px) {
  .bg-img {
    background-position: 10% -8rem;
    background-color: #007632;
  }
}

@media only screen and (min-width: 768px) {
  .bg-img {
    background-position: 18% -5rem;
    background-color: #007632;
  }
}

.conteudo {
  max-width: 100%;
  min-width: 100%;
  padding-bottom: 15px;
  padding-top: 15px;
  display: flex;
  flex-direction: column;
}

.logo {
  max-width: 165px;
}

.navbar {
  background-color: #ffffff !important;
}

.nav-link {
  display: block;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 400;
}
</style>
